import { PartialPick } from "../../../../constants";
import { RootState } from "../../../../models";
import { PickupPoint, PickupPointState } from "../../../../models/state";

export type State = PartialPick<RootState, "pickupPoint">;
export const getPickupPoint = (state: State): PickupPointState | undefined => state.pickupPoint;
export const getPickupPointPoints = (state: State): PickupPoint[] => getPickupPoint(state)?.points || [];
